import React from 'react'
import { DashboardLayout } from '../layouts'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { EditResponseForm, ResponseDetailContainer, ModalContainer } from '../containers';
import services from '../../ioc/services';
import { BsSend, BsTrash } from 'react-icons/bs';
import { InputField } from '../components';
import Lottie from 'lottie-react';
import animation from '../../application/assets/animations/analytic-loader-animation.json'
import ROUTES from '../../application/utils/Routes';


function ResponseDetail() {

    const params = useParams();

    const navigate = useNavigate();

    const [responseId] = useState(params.id);

    const [response, setResponse] = useState(null)

    const [responseAnalysis, setResponseAnalysis] = useState([]);

    const [newChat, setNewChat] = useState('');

    const [isProcessingResponse, setIsProcessingresponse] = useState(false);

    const [isEditing, setIsEditing] = useState(false);

    const [isDeleting, setIsDeleting] = useState(false);

    const [isClearingChat, setIsClearingChat ] = useState(false);

    useEffect(() => {
        services.api.form.getResponseById(responseId)
            .then(res => {
                setResponse(res)
            })
            .catch(err => { console.log(err) })

        services.api.form.getResponseAnalysisById(responseId)
            .then(res => {

                setResponseAnalysis(res)
            })
            .catch(err => { console.log(err) })
    }, [responseId])

    const handleResponseDelete = () => {

        setIsDeleting(false)

        services.api.form.deleteResponse(responseId)
            .then(res => {
                services.alert.toast.success("Response Deleted Successfuly")
                navigate(ROUTES.RESPONSES)
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }

    const addNewChat = () => {

        const chat = { newChat };

        setIsProcessingresponse(true);

        services.api.form.analyseResponseById(responseId, chat)
            .then(res => {

                setNewChat('');
                setResponseAnalysis(res)
            })
            .catch(err => services.alert.toast.error(err))
            .finally(() => {
                setIsProcessingresponse(false);
            })

    }

    const deleteResponseAnalysis = () => {

        services.api.form.deleteResponseAnalysis(responseId)
            .then(res => {
                services.alert.toast.success("Response Analysis Deleted Successfuly")
                window.location.reload();
            })
            .catch(err => {
                services.alert.toast.error(err)
            })
    }

    return (
        <DashboardLayout>


            {response &&
                <div className='grid grid-cols-2 h-full'>
                    <div className=' overflow-y-auto p-2 px-4'>
                        <div className='mb-3 font-bold'>RESPONSE: {response._id}</div>
                        <div className='mb-3 font-bold'>FORM: {response.form.title}</div>
                        <div className='mb-3 font-bold'>FILLED BY: {response.filledBy.firstName} {response.filledBy.lastName}</div>
                        <div className='mb-3 font-bold'>
                            SUBMITTED:  {format(new Date(response.createdAt), "PPPp")}
                        </div>

                        {!isEditing &&
                            <button
                                className=' bg-green-500 text-white px-6 py-2 rounded-md'
                                onClick={() => setIsEditing(true)}>
                                Edit
                            </button>}

                        {
                            isEditing && <div className='flex gap-4'>
                                <button className=' border border-red-500 text-red-500 px-6 py-2 rounded-md' onClick={() => setIsDeleting(true)}>Delete Response</button>
                                <button className=' bg-red-500 text-white px-6 py-2 rounded-md' onClick={() => setIsEditing(false)}>Cancel Edit</button>
                            </div>
                        }

                        <div>

                            <h1 className=' text-xl font-bold mt-5'>RESPONSES</h1>

                            {!isEditing && <ResponseDetailContainer response={response} />}
                            {isEditing && <EditResponseForm response={response} />}

                        </div>
                    </div>

                    <div className='flex flex-col p-2 h-full max-h-full'>

                        <div>
                            <h1 className='text-center font-bold text-lg mb-2'>Analyze Your Response ✨</h1>
                            <p className=' text-xs italic text-center'>UfarmX is powered by Artificial Intelligence. Converse with  UfarmX and get insight on your response</p>
                        </div>
                        <div className=' max-h-[80vh] flex-1 h-full overflow-y-auto my-2 p-2 flex flex-col gap-3'>

                            {responseAnalysis.map(analysis =>
                                <span
                                    className={` bg-green-50 text-sm leading-relaxed p-3 w-2/3 rounded-b-lg ${analysis.role == 'user' ? ' rounded-l-lg ml-auto' : 'rounded-r-lg bg-slate-50'}`}>
                                    <pre className=' whitespace-pre-wrap'>  {analysis.content}</pre>
                                    {/* {analysis.content} */}
                                </span>
                            )}


                        </div>
                        <div className='flex p-2 gap-4 items-center'>

                            <InputField value={newChat} disabled={isProcessingResponse} type='text' className=' flex-1' placeholder="Enter your question" onChange={(e) => setNewChat(e.target.value)} />

                            {!isProcessingResponse && <button className='flex justify-center items-center bg-green-500 rounded-full w-8 h-8 text-white' onClick={addNewChat} >
                                <BsSend />
                            </button>}

                            {!isProcessingResponse && <button className='flex justify-center items-center bg-red-500 rounded-full w-8 h-8 text-white' onClick={()=>setIsClearingChat(true)} >
                                <BsTrash />
                            </button>}

                            {isProcessingResponse &&
                                <div className='h-12'>
                                    <Lottie animationData={animation} loop={true} className="h-full" />
                                </div>
                            }

                        </div>

                    </div>

                    {isDeleting && <ModalContainer
                        title="Delete Response"
                        isOpen={isDeleting}
                        setIsOpen={setIsDeleting}
                        contentStyle={
                            {
                                maxWidth: '500px',
                                maxHeight: '300px',
                                margin: 'auto',
                            }
                        }
                    >
                        <div>
                            <p className=' text-center'>Are you sure you want to delete this response?</p>

                            <div className=' grid justify-around grid-cols-2 gap-8 items-center mt-12'>
                                <button
                                    onClick={handleResponseDelete}
                                    className='bg-red-400 text-white text-sm rounded-lg py-2 px-6'>Yes</button>
                                <button
                                    onClick={() => setIsDeleting(false)}
                                    className='bg-slate-500 text-white text-sm rounded-lg py-2 px-6'>No</button>
                            </div>
                        </div>

                    </ModalContainer>}

                    {isClearingChat && <ModalContainer
                        title="Clear Chat"
                        isOpen={isClearingChat}
                        setIsOpen={setIsClearingChat}
                        contentStyle={
                            {
                                maxWidth: '500px',
                                maxHeight: '300px',
                                margin: 'auto',
                            }
                        }
                    >
                        <div>
                            <p className=' text-center'>Are you sure you want to clear this chat?</p>

                            <div className=' grid justify-around grid-cols-2 gap-8 items-center mt-12'>
                                <button
                                    onClick={deleteResponseAnalysis}
                                    className='bg-red-400 text-white text-sm rounded-lg py-2 px-6'>Yes</button>
                                <button
                                    onClick={() => setIsClearingChat(false)}
                                    className='bg-slate-500 text-white text-sm rounded-lg py-2 px-6'>No</button>
                            </div>
                        </div>

                    </ModalContainer>}

                </div>
            }

        </DashboardLayout>
    )
}

export default ResponseDetail